/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BulkStoresAmenitiesListResponse } from '../../models/bulk-stores-amenities-list-response';

export interface BulkStoreAmenitiesGetAll$Params {
  'Active-Tenant-Identifier': string;

/**
 * DEPRECATED. Use "page" instead
 *
 * @deprecated
 */
  start?: string;

/**
 * Size of the results page.
 */
  size?: number;
  startDate?: string;
  endDate?: string;
  status?: 'IN_PROGRESS' | 'SUCCESS' | 'ERROR';
}

export function bulkStoreAmenitiesGetAll(http: HttpClient, rootUrl: string, params: BulkStoreAmenitiesGetAll$Params, context?: HttpContext): Observable<StrictHttpResponse<BulkStoresAmenitiesListResponse>> {
  const rb = new RequestBuilder(rootUrl, bulkStoreAmenitiesGetAll.PATH, 'get');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.query('start', params.start, {});
    rb.query('size', params.size, {});
    rb.query('startDate', params.startDate, {});
    rb.query('endDate', params.endDate, {});
    rb.query('status', params.status, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BulkStoresAmenitiesListResponse>;
    })
  );
}

bulkStoreAmenitiesGetAll.PATH = '/summary-bulk-store-amenities';
